// extracted by mini-css-extract-plugin
export var closeButton = "_f2-2";
export var closeButtonIcon = "_f2-3";
export var lightboxContent = "_f2-1";
export var lightboxOverlay = "_f2-0";